const getCurrencyValue = (formattedCurrencyValue) => {
  return formattedCurrencyValue && Number(formattedCurrencyValue.replace(/,|\s|₩/g, ''))
}
export const set = (property) => (state, payload) => (state[property] = payload)

export const setCurrency = (property) => (state, payload) => {
  state[property] = getCurrencyValue(payload)
}

export const toggle = (property) => (state) => (state[property] = !state[property])
